import { LegacySchema, LegacySchemaField } from '@/types/legacy-schema';

export type Callback = (arg: Record<string, any>) => void;

interface ITraverse {
  callback: Callback;
  path?: string;
  parent?: LegacySchemaField;
}

function fieldsTraverse(fields: LegacySchema, args: ITraverse) {
  const { callback, path = '', parent = undefined } = args;
  Object.entries(fields).forEach(([key, field]) => {
    const currentPath = path ? `${path}.${key}` : key;
    callback({ field, key, path: currentPath, parent });
    if ('fields' in field) {
      fieldsTraverse(field.fields, {
        callback,
        path: `${currentPath}.fields`,
        parent: field
      });
    }
  });
}

function traverse({ schema }: { schema: LegacySchema }, callback: Callback): void {
  fieldsTraverse(schema, {
    callback
  });
}

export const schemaTraverse = {
  traverse
};
